import { render, staticRenderFns } from "./repair-file-upload.vue?vue&type=template&id=679fb4f2"
import script from "./repair-file-upload.vue?vue&type=script&lang=ts"
export * from "./repair-file-upload.vue?vue&type=script&lang=ts"
import style0 from "./repair-file-upload.vue?vue&type=style&index=0&id=679fb4f2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports